import { PasswordInput } from "../components/PasswordInput";
import { CoreInput } from "../components/CoreInput";
import { MaskedInput } from "../components/MaskedInput";
import { TextArea } from "../components/TextArea";
// todo: fix any type
var getInputInstanceByProps = function getInputInstanceByProps(_ref) {
  var type = _ref.type,
    maskSettings = _ref.maskSettings,
    isTextArea = _ref.isTextArea;
  if (isTextArea) {
    return TextArea;
  }
  if (type === 'password') {
    return PasswordInput;
  }
  if (maskSettings) {
    return MaskedInput;
  }
  return CoreInput;
};
export { getInputInstanceByProps };